import { Zap, Bot, ShieldPlus, Globe2, User, BellRing } from "lucide-react";

const reasons = [
  { icon: Zap, title: "Easy to Use", desc: "A guided, delightful experience." },
  { icon: Bot, title: "AI Powered", desc: "State-of-the-art models under the hood." },
  { icon: ShieldPlus, title: "Prevention Focused", desc: "Insights before symptoms." },
  { icon: Globe2, title: "Accessible Anywhere", desc: "Any device, anytime." },
  { icon: User, title: "Personalized Insights", desc: "Tailored to your profile." },
  { icon: BellRing, title: "Awareness Before Symptoms", desc: "Detect early signals." },
];

export default function WhyChoose() {
  return (
    <section
      data-testid="why-choose-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400">
              Value / 04
            </p>
            <h2 className="font-display mt-4 text-4xl sm:text-5xl font-semibold tracking-tight">
              Why choose <span className="text-gradient-cyan">SilentScan AI</span>?
            </h2>
            <p className="mt-5 text-lg text-zinc-400 max-w-md">
              A companion designed with clarity, privacy, and prevention at its
              core. Because the best time to know is now.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {reasons.map((r, i) => (
              <div
                key={r.title}
                data-testid={`reason-${i}`}
                className="group glass-card rounded-2xl p-5 flex items-start gap-4 transition-all duration-300 hover:border-cyan-400/30 hover:-translate-y-0.5"
              >
                <div className="w-10 h-10 shrink-0 rounded-xl bg-gradient-to-br from-[#0B3D91] to-cyan-500/60 flex items-center justify-center shadow-[0_0_20px_rgba(0,229,255,0.15)]">
                  <r.icon className="w-5 h-5 text-white" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="font-display font-semibold text-white tracking-tight">
                    {r.title}
                  </h3>
                  <p className="mt-1 text-sm text-zinc-500 leading-snug">{r.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
